export default __webpack_public_path__ + "static/media/onboarding-aside.a66b414d.png";